// Core
import React, { useState } from 'react'

// Custom layout
import MainLayout from '../../../Layouts/Main'

//styles
import "./styles.scss"

//router
import { NavLink, useLocation, useNavigate, Outlet, Link } from "react-router-dom";


const Request = () => {

  const requestNavLinks = [{
    to: "purchaseRequest",
    label: "Enquires",
    id: "1",
  },
  {
    to: "failureAnalysisRequest",
    label: "Failure Analysis Request",
    id: "2",
  },
  {
    to: "callRequest",
    label: "Consultation Request",
    id: "3",
  },
  {
    to: "maintenanceRequest",
    label: "Maintenance Assessment",
    id: "4",
  },
  {
    to: "creditRequest",
    label: "Credit Request",
    id: "5",
  },
{
    to: "conditionMonitoringRequest",
    label: "Condition Monitoring Request",
    id: "5",
  }]

  return (
    <MainLayout pageName={"Requests"}>
    <div className='requestContainer1'>
      <div className="requestNavBar">
        {requestNavLinks.map((option)=>(
          <div key={option.id} className="requestOptionContainer">
            <NavLink
              key={option.id}
              to={option.to}
              style={{textDecoration:"none"}}
              className={({ isActive }) =>
                isActive ? "active-requestOptionContainerNav" : "requestOptionContainerNav"
              }
            >
              {option.label}
            </NavLink>
          </div>
        ))}
      </div>
      <Outlet/>
    </div>
    </MainLayout>
  )
}

export default Request
